import { useAuth } from '../context/AuthContext';

/**
 * The signed-in user's department, and the words each department uses on
 * screens the two share. IT groups branches into Regions; BioMedical calls the
 * same master Entities (its sidebar and page names already do).
 *
 * Use these instead of writing "IT" or "Region" into a shared screen: a
 * literal only reads correctly in one department.
 */
const TERMS = {
  IT: {
    name: 'IT',
    region: 'Region',
    regions: 'Regions',
  },
  BM: {
    name: 'BioMedical',
    region: 'Entity',
    regions: 'Entities',
  },
};

export default function useDepartment() {
  const { user } = useAuth();
  const code = user?.department_code || 'IT';
  const terms = TERMS[code] || TERMS.IT;
  return {
    code,
    isBioMedical: code === 'BM',
    // Category Type (Software / Hardware) is an IT-only split
    usesCategoryType: code === 'IT',
    ...terms,
  };
}
